import { useMemo } from 'react';
import dayjs from 'dayjs';

const useRelativeDate = (date: string | null | undefined): string => useMemo(() => {
  if (!date) return '';

  const now = dayjs();
  const targetDate = dayjs(date);
  const daysDiff = now.diff(targetDate, 'day');

  if (daysDiff < 1) return 'Today';
  if (daysDiff >= 1 && daysDiff < 2) return 'Yesterday';
  if (daysDiff >= 2 && daysDiff < 7) return 'This week';
  if (daysDiff >= 7 && daysDiff < 31) return 'This month';
  if (daysDiff >= 31 && daysDiff < 62) return 'Last month';
  if (daysDiff >= 62 && daysDiff < 365) return 'This year';

  return 'A Few years ago';
}, [date]);

export default useRelativeDate;
